import styled from "@emotion/styled"
import React, { useState } from "react"
import MovieImage from "./images/movie-image"
import PropTypes from "prop-types"

const YouTube = ({ youtubeId, movieImage }) => {
  let loadYT = false
  let playerId = `player_${youtubeId}`
  let player = null
  const [isLoadYouTubeIframeAPI, setIsLoadYouTubeIframeAPI] = useState(false)
  const [showMovie, setShowMovie] = useState(false)
  const onPlayerReady = () => {
    player.playVideo()
  }
  const onPlayerStateChange = event => {
    const YT = window.YT
    // 現在のプレーヤーの状態を取得
    var ytStatus = event.data
    // 再生終了したとき
    if (ytStatus === YT.PlayerState.ENDED) {
      // 動画再生
      setShowMovie(false)
    }
  }
  const createMovie = () => {
    console.log("createMovie")
    player = new window.YT.Player(playerId, {
      height: "360",
      width: "640",
      videoId: youtubeId,
      playerVars: {
        rel: 0,
      },
      events: {
        onReady: onPlayerReady, //API呼び出しの受信を開始する準備ができると起動
        onStateChange: onPlayerStateChange, // プレーヤーの状態が変わると起動
      },
    })
  }

  const onClickMovieImage = () => {
    player = null

    if (isLoadYouTubeIframeAPI) {
      setTimeout(() => {
        createMovie()
      }, 100)
    }
    if (window.YT) {
      setIsLoadYouTubeIframeAPI(true)
      setTimeout(() => {
        createMovie()
      }, 100)
    } else {
      if (!loadYT) {
        loadYT = new Promise(resolve => {
          const tag = document.createElement("script")
          tag.src = "https://www.youtube.com/iframe_api"
          const firstScriptTag = document.getElementsByTagName("script")[0]
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
          window.onYouTubeIframeAPIReady = () => {
            resolve(window.YT)
          }
        })
      }
      loadYT.then(() => {
        setIsLoadYouTubeIframeAPI(true)
        createMovie()
      })
    }

    setShowMovie(true)
  }
  const Container = styled.div`
    position: relative;
    top: 0;
    left: 0;
  `
  const MovieImageWrapper = styled.div`
    border: solid 3px #c7a542;
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
     z-index: ${showMovie ? 1 : 2};
    opacity: ${showMovie ? 0 : 1};
    transition:opacity 1s ease-in-out;
    // visibility: ${showMovie ? "hidden" : "visible"};
    cursor: pointer;
  `
  const PlayIcon = styled.svg`
    width: 80px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 20;
  `

  const YouTubeWrapper = styled.div`
    display: ${showMovie ? "block" : "none"};
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: ${showMovie ? 2 : 1};
  `

  return (
    <Container>
      <MovieImageWrapper onClick={() => onClickMovieImage()}>
        <PlayIcon viewBox="0 0 83 83" version="1.1">
          <g stroke="none" fill="none">
            <polygon
              id="Triangle"
              stroke="#D4001C"
              strokeWidth="4"
              fill="#D4001C"
              strokeLinejoin="round"
              transform="translate(45.000000, 42.000000) rotate(-270.000000) translate(-45.000000, -42.000000) "
              points="45 21 66 63 24 63"
            ></polygon>
            <circle
              id="Oval"
              stroke="#D4001C"
              strokeWidth="3"
              cx="41.5"
              cy="41.5"
              r="39.5"
            ></circle>
          </g>
        </PlayIcon>
        <MovieImage fileName={movieImage}></MovieImage>
      </MovieImageWrapper>
      <YouTubeWrapper>
        <div
          className="video"
          style={{
            position: "relative",
            paddingBottom: "56.25%" /* 16:9 */,
            overflow: `hidden`,
            height: 0,
          }}
        >
          {showMovie && <div id={playerId}></div>}
        </div>
      </YouTubeWrapper>
    </Container>
  )
}
YouTube.propTypes = {
  youtubeId: PropTypes.string,
  movieImage: PropTypes.string,
}

export default YouTube
